"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
exports.default = axios_1.default.create({
    baseURL: 'https://aibprtsk.com/admin_api/v1/',
    headers: {
        "Api-Key": `3cb7fc37d5cc231107f649e27dc9b0cb`,
    },
});
